<template>
  <v-dialog v-model="active" width="600">
    <template v-slot:activator="{ on }">
      <v-list-item v-on="on">
        <v-list-item-title style="white-space:normal">World Languages Placement Test</v-list-item-title>
      </v-list-item>
    </template>
    <v-card>
      <v-toolbar>
        <v-toolbar-title>World Languages Placement Test</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="active = false">
          <v-icon>fal fa-times</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text style="margin-top:2em">
        <p>Please select what placement test you are planning to take. Once you click the "Start Test" button, you will be redirected to the placement test you have chosen through our partner site.</p>
        <v-select v-model="assessmentId" :items="tests" label="Placement Test" outlined hide-details>
          <template v-slot:item="{ item, on, attr }">
            <v-list-item v-on="on" v-bind="attr" :disabled="item.disabled">
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
                <v-list-item-subtitle v-if="item.subtext">{{ item.subtext }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
        <p v-if="assessmentId === 'latin'">The Latin test is run through Canvas. When you click the link below, a new window will open, taking you to the latin test in Canvas. Note that there is a delay between when you complete the test and when it will be updated in Scots Connect, typically less than 1 day.</p>
        <p v-else>Upon completing the test, you will be directed back to Scots Connect for your test to be recorded. At that point it should automatically be removed from your to-do list.</p>
      </v-card-text>
      <v-card-actions>
        <v-btn :disabled="assessmentId === '' || isLoading" color="success" @click="startTest()">{{ isLoading ? 'Loading Test...' : 'Start Test Now' }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="info" @click="dismiss()">Not Taking Test</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { onMounted, ref, computed } from '@vue/composition-api'
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {
          title: '',
          link: '',
          dialogText: '',
          added: new Date(),
          viewed: null,
          clicked: null,
          done: false,
          dismissed: false,
          linkText: 'Take test now',
          dismissText: 'Already Taken or Not Taking'
        }
      }
    }
  },
  setup (props, { root }) {
    const user = computed(() => root.$store.state.user)
    const service = root.$feathers.service('orientation/language-placement')
    const active = ref(false)
    const tests = ref([])
    const assessmentId = ref('')
    const link = ref('')

    onMounted(async () => {
      const { data } = await service.find({ query: { report: 'assessments' } })
      tests.value = data.map(({ name: text, assessmentId: value }) => { return { text, value } })
      tests.value.push(({ value: 'latin', text: 'Latin' }))
      tests.value.sort((a, b) => a.text < b.text ? -1 : 1)
      // Also, check and see if the current user has an entry; if so, then they've already selected a test
      // In this case, check to see if the url has expired. If so, we will generate a new link when they click the button.
      const { data: testData } = await service.find({ query: { pidm: user.value.pidm } })
      for (const { _id, assessmentId, score } of testData) {
        const i = tests.value.findIndex(({ value }) => assessmentId === value)
        if (i >= 0) {
          if (score) tests.value.splice(i, 1, { ...tests.value[i], disabled: true, subtext: 'You\'ve already taken this test' })
          else tests.value.splice(i, 1, { ...tests.value[i], assessmentLink: _id })
        }
      }
    })

    async function dismiss () {
      // Find the item that matches the title
      const { _id, actions } = await root.$store.dispatch('getTracker')
      for (let i = 0; i < actions.length; i++) {
        if (actions[i].title === props.item.title) {
          root.$feathers.service('orientation/tracker').patch(_id, { ['actions.' + i + '.dismissed']: true }).then(({ actions }) => {
            active.value = false
            root.$store.commit('setActions', actions)
          })
          break
        }
      }
    }

    const isLoading = ref(false)
    async function startTest () {
      if (link.value === 'new') {
        // ...
      } else if (assessmentId.value === 'latin') {
        window.open(props.item.link)
      } else if (link.value === '') {
        isLoading.value = true
        const rec = tests.value.find(({ value }) => value === assessmentId.value)
        const language = rec ? rec.text.split(' ')[0] : assessmentId.value
        const data = await service.create({ language, assessmentId: assessmentId.value })
        if ('signInUrl' in data) {
          document.location = data.signInUrl
        } else {
          alert('There was an error loading the language test. Please try again or contact techsupport@covenant.edu for assistance.')
          isLoading.value = false
        }
      } else {
        document.location = link.value
      }
    }

    return {
      active,
      tests,
      assessmentId,
      link,
      dismiss,
      isLoading,
      startTest
    }
  }
}
</script>
